export const FACILITIES_TYPES = {
  LOAD_FACILITIES: "LOAD_FACILITIES",
  SET_FACILITIES: "SET_FACILITIES",
  CLEAR_FACILITIES: "CLEAR_FACILITIES",
  // new facility
  NEW_FACILITY: "NEW_FACILITY",
  SEND_NEW_FACILITY: "SEND_NEW_FACILITY",
  SET_NEW_FACILITY: "SET_NEW_FACILITY",

  EDIT_FACILITY: "EDIT_FACILITY",
  SET_EDITED_FACILITY: "SET_EDITED_FACILITY",
  DELETE_FACILITY: "DELETE_FACILITY",
  HANDLE_FACILITIES_INPUTS: "HANDLE_FACILITIES_INPUTS"
};
